module.exports = __webpack_public_path__ + "img/prioritas_interpackmaxi_dg_k.fe4a11d3.png";